export default __webpack_public_path__ + "static/media/exercise.e03b7fd2.jpg";